import React from 'react';

/**
 * Smaller compact down-chevron variant (h-3.5 w-3.5 default) used in dense
 * UI lists like `QueryResultRow`. Filled, 20x20 viewBox.
 */
export function ChevronDownSmallIcon({
  className = 'h-3.5 w-3.5',
}: {
  className?: string;
}): React.ReactElement {
  return (
    <svg className={className} viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
      <path
        fillRule="evenodd"
        d="M5.23 7.21a.75.75 0 011.06.02L10 11.06l3.71-3.83a.75.75 0 011.08 1.04l-4.25 4.39a.75.75 0 01-1.08 0L5.21 8.27a.75.75 0 01.02-1.06z"
        clipRule="evenodd"
      />
    </svg>
  );
}
